import React from "react";
import { Modal } from "@nef/core";
import styled from "styled-components";

const StyledFormErrorModal = styled(Modal)`
  &.form-error-modal {
    div > div {
      top: 50%;
    }
    .text {
      font-size: 16px;
      font-family: sans-serif;
      padding-left: 0.5em;
      padding-top: 1em;
      padding-bottom: 1em;
    }
    Button {
      margin: 0;
    }
  }
`;

export default StyledFormErrorModal;
